module.exports = __webpack_public_path__ + "static/media/maryland-state-championship-2023.18df36ce.png";